module.exports = __webpack_public_path__ + "static/media/4.be58671b.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/mouth/4.png
// module id = 1353
// module chunks = 0